import { BrowserRouter as Router } from "react-router-dom";

import { ApplicationRouter } from "./features/application-router/ApplicationRouter";

// This must be in the App component and not in index.ts to properly
// setup configuration overrides

function App() {
  return (
    <Router>
      <ApplicationRouter />
    </Router>
  );
}

export default App;
